export const tableRows = [
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Zmejuka',
    time: '60s',
    wager: 400,
    multi: '0.5X',
    amount: 3500000,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Annaila',
    time: '46s',
    wager: 400,
    multi: '0.5X',
    amount: 1928383.0,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Zuxamala',
    time: '25s',
    wager: 400,
    multi: '0.5X',
    amount: 1999988.23,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Zmila',
    time: '45s',
    wager: 400,
    multi: '0.5X',
    amount: 35,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Adola',
    time: '55s',
    wager: 400,
    multi: '0.5X',
    amount: 99.2345,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Kevin',
    time: '8s',
    wager: 400,
    multi: '0.5X',
    amount: 1,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Micale',
    time: '1s',
    wager: 400,
    multi: '0.5X',
    amount: 500000,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Olahama',
    time: '20s',
    wager: 400,
    multi: '0.5X',
    amount: 51689886.55,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Zalinila',
    time: '5s',
    wager: 400,
    multi: '0.5X',
    amount: 1000,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Zucenta',
    time: '15s',
    wager: 400,
    multi: '0.5X',
    amount: 100000,
  },
  {
    game: '/assets/ava-game.png',
    gameName: 'The Doghouse Megaways',
    user: '/assets/ava4.png',
    name: 'Hanaxara',
    time: '10s',
    wager: 400,
    multi: '0.5X',
    amount: 10000.1,
  },
]
